/** Created by azhou on 2018/10/24.*/
<template>
  <div id="actiWrap">
    <h4 class="bg-base p-3 mt-4 mb-2 text-left">活动种类</h4>
    <!--添加活动-->
    <div id="addActi" class="pb-3">
      <div class="d-center-start mb-3">
        <left-text leftText="活动类型"/>
        <el-radio-group v-model="actiChilds.onsale_type">
          <el-radio :label="item.value" :key="item.name" v-for="item in [{value:1,name:'场次'},{value:2,name:'人次'}]">{{item.name}}</el-radio>
        </el-radio-group>
        <el-button type="primary" class="ml-auto" size="small" @click="addActiType">{{actiChilds.id>0?'保存修改':'确定添加'}}</el-button>
      </div>
      <left-text-border leftText="类型标题" placeholder="例如：整日包场" v-model="actiChilds.son_title"/>
      <div class="bg-base mb-3 p-3 d-center-between mt-3">
        <div class="d-center-start">门市价：
          <div class="bg-white">
            <span class="text-blue border-right pl-3 pr-3">&yen;</span>
            <input type="number" class="price-input" v-model="actiChilds.price_0">
            <span class="price-label p-2">元 / {{actiChilds.onsale_type==1?'场':'人'}}</span>
          </div>
        </div>
        <div class="d-center-end">采购商价：
          <div class="bg-white">
            <span class="text-blue border-right pl-3 pr-3">&yen;</span>
            <input type="number" class="price-input" v-model="actiChilds.price_1">
            <span class="price-label p-2">元 / {{actiChilds.onsale_type==1?'场':'人'}}</span>
          </div>
        </div>
      </div>
      <div class="d-center-start" v-if="actiChilds.onsale_type==2">
        <left-text-border leftText="最少预订量" v-model.number="actiChilds.min_nums" appendText="人" class="w-30"/>
        <left-text-border leftText="最大限制" v-model.number="actiChilds.max_nums" appendText="人" class="ml-auto w-30"/>
        <span class="text-muted mr-4">（0为不限）</span>
      </div>
      <div class="d-center-start" v-if="actiChilds.onsale_type==1">
        <left-text leftText="人数限制"/>
        <el-input size="small" v-model="actiChilds.min_nums" class="w-10" type="number"><span slot="append">人</span></el-input>
        <hr style="width: 15px;background: #000;margin:0 5px;"/>
        <el-input size="small" v-model="actiChilds.max_nums" class="w-10" type="number"><span slot="append">人</span></el-input>
        <span class="text-muted mr-4">（0为不限）</span>
      </div>
    </div>
    <!--活动列表-->
    <div class="mt-5 text-center" v-show="actiLists.length>0">
      <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
      <ul class="list-item" v-for="Itemize in actiLists" :key="Itemize.id">
        <li class="w-50 list-item-col">{{Itemize.son_title || Itemize.name}}</li>
        <li class="w-50 list-item-col">{{(Itemize.onsale_type || Itemize.type)==1?'场次':'人次'}}</li>
        <li class="w-50 list-item-col flex-column">
          <span>门市价：&yen;{{Itemize.price_0}}</span>
          <span>采购商价：&yen;{{Itemize.price_1}}</span>
        </li>
        <li class="w-50 list-item-col">
          至少{{Itemize.min_nums + '-' + (Itemize.max_nums > 0 ? Itemize.max_nums : '不限')}} 人
        </li>
        <li class="w-50 list-item-col" :class="[Itemize.status ? 'text-success' : 'text-danger']">
          {{Itemize.status ? '已发布' : '待审核'}}
        </li>
        <li class="w-50 list-item-col-end" v-if="userInfo.type===5">
          <span class="text-link mr-2" @click="editActiItem(Itemize)">编辑</span>
          <span class="text-link" @click="deleteItem(Itemize)">删除</span>
        </li>
        <li class="w-50 list-item-col-end" v-else>
          <el-button type="success" size="small" :disabled="Boolean(Itemize.status)"
                     @click="$emit('verify',Itemize.id,Itemize.onsale_type)">审核通过</el-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {mapState,mapGetters,mapActions} from 'vuex'

  export default {
    data() {
      return {
        actiChilds: {            //活动种类信息
          onsale_type: 1,        //活动类型：场次/人次
          son_title: '',         //活动类型标题
          price_0: '',           //门市价
          price_1: '',           //团队优惠价
          min_nums:'',           //最少预订量
          max_nums:'',           //最大人数限制
        },
        disabledFlag:false,
        titleArr: ['名称','活动类型','价格','详情','状态','操作']
      }
    },
    computed: {
      ...mapState(['discountDetail']),
      ...mapGetters(['userInfo']),
      discountId () { return this.$route.query.discount },
      actiLists() { return this.discountDetail.son_price_arr || [] }
    },
    methods: {
      ...mapActions(['addEditActiType','deleteActiType']),
      /*添加活动类型验证*/
      validateActiType() {
        if (!this.actiChilds.son_title) return {flag: false, msg: '请添加类型标题'};
        if (!this.$GFUN.isMoneyRight(this.actiChilds.price_0) || !this.$GFUN.isMoneyRight(this.actiChilds.price_0)) return {flag: false, msg: '价格填写不正确'};
        if (Number(this.actiChilds.min_nums) <= 0) return {flag: false, msg: '最低限制不得少于1'};
        if (this.actiChilds.max_nums === '' || Number(this.actiChilds.max_nums) < 0) return {flag: false, msg: '最高限制不得少于0，若不限请填0'};
        return {flag: true, msg: '验证通过'}
      },
      /*添加活动类型*/
      addActiType() {
        let result = this.validateActiType();
        if (result.flag) {
          this.addEditActiType({
            type: this.actiChilds.id > 0 ? 'edit' : 'add',
            data: {
              homestay_onsale_id: this.discountId,
              homestay_onsale_details_id: this.actiChilds.id,
              ...this.actiChilds,
            }
          })
        } else this._alert(result.msg, null,'error');
      },
      /*编辑活动类型*/
      editActiItem(item) {
        this.actiChilds = Object.assign({}, item);       //给修改框赋值
        $('html,body').animate({scrollTop:$('#actiWrap').offset().top},800);  //滚动到修改位置
        this.shake($('#addActi'),'selectshake');        //闪烁提醒
      },
      /*边框闪烁*/
      shake(ele, cls, time) {
        let i = 0, t = false, o = ele.attr('class') + ' ', c = '', times = time || 2;
        if (t) return;
        t = setInterval(function () {
          i++;
          c = i % 2 ? o + cls : o;
          ele.attr('class', c);
          if (i == 2 * times) { clearInterval(t); ele.removeClass(cls); }
        }, 400);
      },
      /*删除活动类型*/
      deleteItem(item) {
        this._confirm('确认删除么？',() => {
          this.deleteActiType(item.id);
        })
      },
    }
  }
</script>
<style lang="scss" scoped>
  .selectshake{background: #e9e9eb;box-sizing: border-box;}
  .price-input {
    appearance: none;
    border: none;
    width: 100px;
    height: 30px;
    padding-left: 10px;
    &:focus {outline: none;}
  }
  .price-label {
    background: #3395D9;
    color: #fff;
    height: 100%;
    display: inline-block;
  }
</style>
